export default __webpack_public_path__ + "static/media/ddsu5168-6.dea71775.png";